const initialState = {
  isExamEditorVisible: false,
  examDGNLEntriesData: [],
  examDGNLEntryData: null,
  isLoadingDGNL: false,
  isModalConfirmDeleteDGNLOpen: false,

  isExamVHEditorVisible: false,
  examVHEntriesData: [],
  examVHEntryData: null,
  isLoadingVH: false,
  isModalConfirmDeleteVHOpen: false,
};

const examReducer = (state = initialState, action) => {
  switch (action.type) {
    case "TOGGLE_EXAM_EDITOR_VISIBLE":
      return {
        ...state,
        isExamEditorVisible: !state.isExamEditorVisible,
      };
    case "TOGGLE_EXAM_UPDATE":
      return {
        ...state,
        isExamEditorVisible: !state.isExamEditorVisible,
        examDGNLEntryData: action.payload,
      };
    case "CLEAR_EXAM_ENTRY_DATA":
      return {
        ...state,
        examDGNLEntryData: null,
      };
    case "TOGGLE_MODAL_CONFIRM_DELETE_DGNL":
      return {
        ...state,
        isModalConfirmDeleteDGNLOpen: !state.isModalConfirmDeleteDGNLOpen,
        examDGNLEntryData: action.payload,
      };
    case "FETCH_DGNL":
      return {
        ...state,
        examDGNLEntriesData: action.payload,
      };
    case "SET_LOADING_DGNL":
      return {
        ...state,
        isLoadingDGNL: action.payload,
      };
    case "FETCH_VH":
      return {
        ...state,
        examVHEntriesData: action.payload,
      };
    case "SET_LOADING_VH":
      return {
        ...state,
        isLoadingVH: action.payload,
      };

    case "TOGGLE_EXAM_VH_EDITOR_VISIBLE":
      return {
        ...state,
        isExamVHEditorVisible: !state.isExamVHEditorVisible,
      };
    case "TOGGLE_EXAM_VH_UPDATE":
      return {
        ...state,
        isExamVHEditorVisible: !state.isExamVHEditorVisible,
        examVHEntryData: action.payload,
      };
    case "CLEAR_EXAM_VH_ENTRY_DATA":
      return {
        ...state,
        examVHEntryData: null,
      };
    case "TOGGLE_MODAL_CONFIRM_DELETE_VH":
      return {
        ...state,
        isModalConfirmDeleteVHOpen: !state.isModalConfirmDeleteVHOpen,
        examVHEntryData: action.payload,
      };
    default:
      return state;
  }
};

export default examReducer;
